const Footer = () => {

    return(
        <>
  <footer className="app-footer">
    <div className="container">
      <div className="row">
        <div className="col-md-3 col-sm-6 col-12 mb-5">
          <div>
            <div className="mb-3">
              <a href="#">
                <img src="/assets/images/logo-white.svg" alt="" />
              </a>
            </div>
            <p className="text">
              Rullier Bois est un négoce bois et dérivés pour la construction,
              la rénovation et l'aménagement. Spécialiste indépendant bois et
              dérivés en Poitou-Charentes depuis 1883, Rullier Bois propose les
              meilleures solutions aux artisans, professionnels du bâtiment et
              particuliers.
            </p>
            <p className="text">
              AU 05 49 29 85 11 OU VIA NOTRE <br />
              FORMULAIRE DE CONTACT.
            </p>
            <a href="#" className="btn btn-primary px-3 rounded-0">
              Nous contacter
            </a>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-6 mb-4">
          <div className="d-flex justify-content-center">
            <div className="">
              <p className="text-white">NOS PRODUITS</p>
              <ul className="menu">
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    BOIS DE CONSTRUCTION
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    AGENCEMENT
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    TERRASSE &amp; EXTÉRIEUR
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    BOIS D'ŒUVRE
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    ISOLATION
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    FAÇADES &amp; BARDAGES
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    SOLS &amp; INTÉRIEUR
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    MENUISERIES
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-6 mb-4">
          <div className="d-flex justify-content-center">
            <div className="">
              <p className="text-white">RULLIER BOIS</p>
              <ul className="menu">
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    ACTUALITÉS
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    QUI SOMMES-NOUS
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    NOS AGENCES
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    NOS SERVICES
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    POLE CONSTRUCTION BOIS
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    NOUS REJOINDRE
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    NOS PARTENARIATS
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-12 mb-4">
          <div className="d-flex justify-content-center">
            <div className="">
              <p className="text-white">INFORMATIONS</p>
              <ul className="menu">
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    CATALOGUES
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    LIVRAISON
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    BOIS ÉCO-CERTIFIÉ
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    GROUPEMENT NEBOPAN
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    DOP
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    CONDITIONS GÉNÉRALES DE VENTE
                  </a>
                </li>
                <li className="menu-item">
                  <a href="#" className="menu-link">
                    MENTIONS LÉGALES
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  {/* Copyrigth */}
  <div className="nos-attouts py-3">
    <div className="container">
      <p className="coptyright-text text-center text-white mb-0">
        © 2023 RULLIER
      </p>
    </div>
  </div>
  {/* footer close */}
</>
    )

}

export default Footer